export const updatedInPastOptions = [
  { title: '30 Days', value: 30 },
  { title: '90 Days', value: 90 },
  { title: '360 Days', value: 360 },
  { title: '720 Days', value: 720 },
];
